<script lang="tsx">
import { ElPagination } from 'element-plus'
import { defineComponent, computed } from 'vue'
import { propTypes } from '@/utils/propTypes'
import type { PropType } from 'vue'
import type { PaginationProps } from './types'

export default defineComponent({
  name: 'Pagination',
  props: {
    // 每页显示条目个数
    pageSize: propTypes.number.def(10),
    // 当前页数
    pageNo: propTypes.number.def(1),
    // 总条目数
    total: propTypes.number.def(0),
    // 每页显示个数选择器的选项设置
    pageSizes: {
      type: Array as PropType<number[]>,
      default: () => [10, 20, 30, 40, 50, 100]
    },
    // 组件布局，子组件名用逗号分隔
    layout: propTypes.string.def('total, sizes, prev, pager, next, jumper'),
    // 是否为分页按钮添加背景色
    background: propTypes.bool.def(true),
    // 是否禁用
    disabled: propTypes.bool.def(false),
    // 只有一页时是否隐藏
    hideOnSinglePage: propTypes.bool.def(false),
    // 是否使用小型分页样式
    small: propTypes.bool.def(false),
    // 页码按钮的数量，当总页数超过该值时会折叠
    pagerCount: propTypes.number.def(7)
  },
  emits: ['update:pageSize', 'update:pageNo', 'pagination-change'],
  setup(props, { emit }) {
    // 分页配置
    const paginationProps = computed(() => {
      return {
        pageSize: props.pageSize,
        pageNo: props.pageNo,
        total: props.total,
        pageSizes: props.pageSizes,
        layout: props.layout,
        background: props.background,
        disabled: props.disabled,
        hideOnSinglePage: props.hideOnSinglePage,
        small: props.small,
        pagerCount: props.pagerCount
      }
    })

    // 处理页码改变
    const handleCurrentChange = (pageNo: number) => {
      emit('update:pageNo', pageNo)
      emit('pagination-change', {
        pageNo,
        pageSize: props.pageSize
      })
    }

    // 处理每页条数改变
    const handleSizeChange = (pageSize: number) => {
      emit('update:pageSize', pageSize)
      emit('pagination-change', {
        pageNo: 1, // 页码重置为1
        pageSize
      })
    }

    return () => (
      <div class="conation">
        <ElPagination
          {...paginationProps.value}
          onUpdate:current-page={handleCurrentChange}
          onUpdate:page-size={handleSizeChange}
        />
      </div>
    )
  }
})
</script>
<style lang="less" scoped>
.conation {
  margin: 10px 0;
}
</style>
